import { ChangePage, ChangeFilters} from "./actions"
import { FilterModel } from "../../shared/filter/models"


export const mapDispatchToProps = (dispatch) => {
    return {
        ChangePage: (page: number) => { dispatch(ChangePage(page)) }, 
        ChangeFilters: (filters: FilterModel[]) => { dispatch(ChangeFilters(filters)) },        
    }
}